import { transformDateValue } from 'core/js/FormUtils';
export const getRmvendorView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let rmvendorList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
              
              
            ],
            'dataList': [
                
              ]
          }

          rmvendorList.push(card);
  })
  return rmvendorList;
}